<input type="file" class="file-input" [accept]="this.accept" (change)="fileChangeEvent($event)" #fileUpload>

<div class="photo-upload {{ this.shape }}" [style.backgroundColor]="color" [nbSpinner]="adapter.isLoading" [nbSpinnerSize]="'large'" (click)="!adapter.isLoading ? pick(fileUpload) : null" [nbTooltip]="'setimage' | translate" nbTooltipStatus="primary" [nbTooltipPlacement]="NbPosition.BOTTOM">
  <nb-icon icon="camera"></nb-icon>
  @if (value && value.preview) {
    <img [src]="Globals.storage(value.preview)" [alt]="value.name">
  }
</div>
